import React from "react";

import { Box } from "@mui/material";
import MainHeader from "../../shared/MainHeader";

import UnassignPubPvtCaseTable from "../../components/UnassignPubPvtCaseTable";

const PubPvtCase = () => {
  return (
    <Box>
      <MainHeader headingText={"Unassigned Public Private Case"} />

      <UnassignPubPvtCaseTable />
    </Box>
  );
};

export default PubPvtCase;
